<template>

    <v-flex xs12 sm12 md10 lg8 offset-md1 offset-lg2>

        <div v-if="banner">

            <div v-for="(banner, i) in banners" :key="i">

                <v-img :src="banner" contain height="auto"></v-img>

            </div>

        </div>

    </v-flex>

</template>

<script>
import Api from "@/api";

export default {
    data() {
        return {
        }
    },
    props: ["banner"],
    computed :{
        banners: function() {
            return this.banner;
        }
    },
    mounted() {
    },
    methods: {

    }
}
</script>

